module.exports = {"220523001":"东凤街道","220523002":"朝辉街道","220523003":"西凤街道","220523100":"朝阳镇","220523101":"辉南镇","220523102":"样子哨镇","220523103":"杉松岗镇","220523104":"石道河镇","220523105":"辉发城镇","220523106":"抚民镇","220523107":"金川镇","220523108":"团林镇","220523109":"庆阳镇","220523200":"楼街朝鲜族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220523.json
// module id = 731
// module chunks = 0